import React from 'react';
function Play({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path d="M5 3L19 12L5 21V3Z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default Play;
